import axios from "axios";
import config from "../config";
export default {
  createUser(context, success, error) {
    // https://stg-scheduler.incus5.com/user/v1.0/onboarding
    axios({
      url: config.URLS.userManagement + "onboarding",
      data: context.addUsersPayLoad,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getUsers(context, success, error) {
    axios({
      url: config.URLS.userManagement + "users",
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getUsersId(id, context, success, error) {
    // user/{version}/profile/id
    axios({
      url: config.URLS.userManagement + `profile/${id}`,
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  changePassword(context, email, payload, success, error) {
    // http://35.235.114.92/api/v1.0/profile/a/resetpassword
    axios({
      url:
        config.URLS.userManagement + `profile/${email}/resetpassword`,
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  updateUsersId(context, id, payload, success, error) {
    axios({
      url: config.URLS.userManagement + `profile?userId=${id}`,
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  loginuserMicrosoft(context, payload, success, error) {
    axios({
      url: config.URLS.userManagement + "login/signin/external",
      data: payload,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  loginuser(context, payload, success, error) {
    axios({
      url: config.URLS.userManagement + "login/signin",
      data: payload,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  updateProfileImage(id, payload, context, success) {
    axios({
      url: config.URLS.userManagement + `profile/${id}/picture`,
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        console.log(errorResponse);
      });
  }
};
